import { Controller } from "@hotwired/stimulus";

// Live "Publicado" / "Agendado para o futuro" badge next to a datetime-local
// field. `datetime-local` carries no timezone, and the browser reads it in the
// visitor's local clock while the server stores America/Sao_Paulo — so this is
// deliberately an *indicator*, not a validation: the server stays the only
// authority on whether a page is published (DiaryPost#published?).
//
// A blank field means "publish now" (the model defaults published_at on save),
// so it reports Publicado rather than going blank.
export default class extends Controller {
	static targets = ["input", "badge"];

	connect() {
		this.render();
	}

	render() {
		if (!this.hasInputTarget || !this.hasBadgeTarget) return;

		const raw = this.inputTarget.value;
		const parsed = raw === "" ? Number.NaN : new Date(raw).getTime();
		// An incomplete value (mid-typing, or a browser that hands back a partial
		// string) parses to NaN — treat it as "now" rather than flashing Agendado.
		const scheduled = !Number.isNaN(parsed) && parsed > Date.now();

		const badge = this.badgeTarget;
		badge.textContent = scheduled ? badge.dataset.scheduledText : badge.dataset.publishedText;
		badge.className = scheduled ? badge.dataset.scheduledClass : badge.dataset.publishedClass;
	}
}
